export const DEFAULT_FORM_SECTION_BACKGROUND_IMAGE =
  'https://res.cloudinary.com/dbbkqtyqn/image/upload/v1755776408/JRTestL/t/Image_w10qm6.png';

export const HERO_SPLIT_VARIANT_IDS = [
  'banner-split',
  'banner-split-left-form',
  'solid-split',
  'solid-split-left-form',
] as const;

export const DEFAULT_FORM_SECTION_VARIANT_ID = 'standard-form';

/** Standard hidden fields included on every contact / hero form. */
export const DEFAULT_FORM_HIDDEN_FIELDS = [
  {
    label: 'UTM Source',
    type: 'hidden',
    name: 'utm_source',
    value: '',
    mapped: 'utm_source',
    placeholder: 'Auto-filled value',
  },
  {
    label: 'UTM Medium',
    type: 'hidden',
    name: 'utm_medium',
    value: '',
    mapped: 'utm_medium',
    placeholder: 'Auto-filled value',
  },
  {
    label: 'UTM Campaign',
    type: 'hidden',
    name: 'utm_campaign',
    value: '',
    mapped: 'utm_campaign',
    placeholder: 'Auto-filled value',
  },
  {
    label: 'UTM Content',
    type: 'hidden',
    name: 'utm_content',
    value: '',
    mapped: 'utm_content',
    placeholder: 'Auto-filled value',
  },
  {
    label: 'UTM Term',
    type: 'hidden',
    name: 'utm_term',
    value: '',
    mapped: 'utm_term',
    placeholder: 'Auto-filled value',
  },
  {
    label: 'UTM ID',
    type: 'hidden',
    name: 'utm_id',
    value: '',
    mapped: 'utm_id',
    placeholder: 'Auto-filled value',
  },
] as const;

export type FormSource = 'section' | 'hero';

export function getFormHiddenFieldsToggleKey(
  sectionId: string | null | undefined,
  formSource: FormSource = 'section'
): string {
  const id = sectionId?.trim() ?? '';
  if (formSource === 'hero') {
    return `${id || 'job_hero_section'}`;
  }
  return id || 'application_form';
}

export function resolveContactFormSectionToggleKey(section: {
  sectionId?: string;
  data?: { id?: string };
  type?: string;
}): string {
  const sectionId = section.sectionId || section.data?.id || section.type || '';
  return getFormHiddenFieldsToggleKey(sectionId, 'section');
}
